import addReadWriteRecipients from './addReadWriteRecipients';
import findReadWriteRecipient from './findReadWriteRecipient';
import setDirectorySearchType from './setDirectorySearchType';
import setIsSearching from './setIsSearching';
import showHideFindResult from './showHideFindResult';
import parseSuspectedDisplayNameEmailAddress from '../utils/parseSuspectedDisplayNameEmailAddress';
import { DirectorySearchType } from 'owa-recipient-common/lib/store/schema/FindControlViewState';
import RecipientWellWithFindControlViewState from 'owa-recipient-common/lib/store/schema/RecipientWellWithFindControlViewState';
import isValidEmailAddress from 'owa-recipient-common/lib/utils/isValidEmailAddress';
import { action } from 'satcheljs/lib/legacy';

export default action('resolveQueryStringToRecipient')(async function resolveQueryStringToRecipient(
    recipientWell: RecipientWellWithFindControlViewState,
    shouldDirectlyResolve: boolean,
    searchDirectory?: boolean,
    resolveIfSingle?: boolean
): Promise<void> {
    setDirectorySearchType(
        recipientWell,
        searchDirectory ? DirectorySearchType.Manual : DirectorySearchType.None
    );
    let inputText = recipientWell.queryString.trim();
    if (inputText) {
        if (shouldDirectlyResolve) {
            setIsSearching(recipientWell, false /* isSearching */);
            // try to parse out a suspected name + email address combo
            let result = parseSuspectedDisplayNameEmailAddress(inputText);
            addReadWriteRecipients(recipientWell, [
                {
                    isValid: isValidEmailAddress(result.EmailAddress.EmailAddress),
                    newPersona: result,
                },
            ]);
        } else {
            if (recipientWell.queryString.indexOf('@') >= 0 && recipientWell.inForceResolve) {
                setIsSearching(recipientWell, false /* isSearching */);
                addReadWriteRecipients(recipientWell, [
                    {
                        isValid: isValidEmailAddress(inputText),
                        newPersona: null,
                        newEmailAddress: inputText,
                    },
                ]);
            } else {
                setIsSearching(recipientWell, true /* isSearching */);
                await findReadWriteRecipient(
                    recipientWell,
                    recipientWell.queryString,
                    searchDirectory,
                    resolveIfSingle
                );
            }
        }
    } else {
        // If query string is empty, hide find result with existing result cleared.
        setIsSearching(recipientWell, false /* isSearching */);
        showHideFindResult(
            recipientWell,
            true /* shouldShowFindResult */,
            true /* shouldClearFindResult */
        );
    }
});
